<template>
  <div>
    <router-view></router-view>
    <GlobalLoader v-if="loading" />
  </div>
</template>

<script setup>
import { computed, watchEffect } from 'vue';
import GlobalLoader from './components/GlobalLoader.vue';
import store from './store';
import { useI18n } from 'vue-i18n';
import { onMounted } from 'vue';
const loading = computed(() => store.state.loading);
const { locale } = useI18n()
onMounted(() => {
  window.addEventListener('app:loader', (e) => {
    store.dispatch('setLoader', e.detail);
  });
});
watchEffect(() => {
  document.documentElement.dir = locale.value === 'he' ? 'rtl' : 'ltr'
})
</script>

<style>

</style>
